<template lang="pug">
  v-app
    template(v-if="xsDevice")
      the-header(
        @toggleDrawer="toggleDrawer"
        :is-drawer-visible="drawer"
      )
      drawer-mobile-nav-menu(
        :value="drawer"
        @closeDrawer="drawer = false"
      )
    drawer(v-else)
    v-main
      v-container(
        fill-height
        fluid
        class="default pa-0 align-start bg"
      )
        nuxt
    notification
    dialogs(ref="dialogs")
    sidebars
    snackbars
    mobile-drawer
    ghost
</template>

<script>
import { mapGetters } from 'vuex'
import notification from './includes/notification'
import dialogs from './includes/dialogs'
import drawer from '~/layouts/includes/drawer'
import TheHeader from '~/layouts/includes/header'
import sidebars from '~/modules/sidebar/views/components/sidebars'
import responsive from '~/mixins/pages/responsive'
import snackbars from '~/layouts/includes/snackbars'
import DrawerMobileNavMenu from '~/layouts/includes/drawer-mobile-navigation-menu'
import MobileDrawer from '~/layouts/includes/mobile-drawer'
import Ghost from '~/layouts/includes/ghost'
import contentDialog from '~/mixins/dialogs/contentDialog'
import premiumPlan from '~/mixins/plans/premiumPlan'

export default {
  components: {
    Ghost,
    MobileDrawer,
    snackbars,
    drawer,
    notification,
    dialogs,
    sidebars,
    TheHeader,
    DrawerMobileNavMenu
  },
  mixins: [responsive, contentDialog, premiumPlan],
  data() {
    return {
      drawer: false
    }
  },
  computed: {
    ...mapGetters('billing', ['shouldShowTrialModal'])
  },
  watch: {
    shouldShowTrialModal(val) {
      if (
        this.$isRegistrationToday &&
        val &&
        !this.$hasProVersion &&
        !this._.get(this.$localStorageClientData, 'trialAccessModal', false)
      ) {
        this.openTrialModal()
      }
    }
  },
  created() {
    this.$isRegistrationToday && this.$store.dispatch('billing/updateTrialModalStatus')
  },
  methods: {
    toggleDrawer() {
      this.drawer = !this.drawer
    },
    async openTrialModal() {
      const isAccept = await this.showPremiumFeaturesModal()

      if (isAccept) {
        window.dataLayer &&
          window.dataLayer.push({
            event: 'onboarding_step_4',
            user_email: this._.get(this.$User, 'login'),
            trial_choice: 'start_trial'
          })
        this.$setLocalStorageClientData({ trialActivation: true, trialAccessModal: true })
      } else {
        window.dataLayer &&
          window.dataLayer.push({
            event: 'onboarding_step_4',
            user_email: this._.get(this.$User, 'login'),
            trial_choice: 'stay_on_free'
          })
        this.$setLocalStorageClientData({ trialAccessModal: true })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#app {
  min-width: 320px !important;
  overflow: hidden;
}
.bg {
  background: $background-primary;
}
</style>
